import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { getDeviceProviderConfigurationListQuery, getThirdPartyDevicesQuery, getVerkadaDeviceDataQuery } from "../../graphql/queries";
import { AddThirdPartyDeviceConfigurationMutation, addThirdPartyDevicesMutation, DeleteDeviceConfigurationMutation } from "../../graphql/mutations";
import { thirdPartyDeviceProviderList, setDeviceList, setLoader, setThirdPartyDeviceReading, setProviderLoader } from "../slices/thirdPartyDeviceSlice";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { setLoaderMeasurement } from "../slices/substanceSlice";

export const fetchDeviceProviderConfigurationList = createAsyncThunk(
    "deviceProviderConfigurationList/fetch",
    async (_request: any, { dispatch }) => {
        dispatch(setProviderLoader(true));
        try {

            const response = await API.graphql({
                ...graphqlOperation(getDeviceProviderConfigurationListQuery, { tenantCode: _request?.tenantCode }),
                authMode: "AMAZON_COGNITO_USER_POOLS",
            }) as { data: any, errors?: any[] };

            dispatch(thirdPartyDeviceProviderList(response?.data?.getDeviceProviderConfigurationList))
            dispatch(setProviderLoader(false));

            // Return the data so it can be handled in your extraReducers
            return response.data;

        } catch (err: any) {
            dispatch(setProviderLoader(false));
            console.error("error ::", err)

        }
    }
);

export const getThirdPartyDevices = createAsyncThunk("thirdPartyDevices", async (_request: any, { dispatch }) => {
    try {

        const response = await API.graphql({
            ...graphqlOperation(getThirdPartyDevicesQuery, { providerId: _request.providerId }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };

        dispatch(setDeviceList(response?.data?.getThirdPartyDevices))

    } catch (err: any) {

        console.error("error ::", err)

    }
})

interface AddThirdPartyDeviceInput {
    deviceId: string;
    providerId: string;
    deviceName: string;
}

// Create the async thunk
export const addThirdPartyDeviceThunk = createAsyncThunk<any, AddThirdPartyDeviceInput>(
    "thirdPartyDevices/add",
    async (input, { dispatch }) => {

        try {
            dispatch(setLoader(true));
            const response = await API.graphql({
                ...graphqlOperation(addThirdPartyDevicesMutation, { devices: input }),
                authMode: "AMAZON_COGNITO_USER_POOLS",
            }) as { data: any; errors?: any[] };

            dispatch(setLoader(false));
            if (response?.data?.addThirdPartyDevices?.success === "true") {
                dispatch(notificationSuccess(response?.data?.addThirdPartyDevices?.message));
                return true;
            } else {
                dispatch(notificationFail(response?.data?.addThirdPartyDevices?.message));
                return false;
            }

        } catch (error: any) {
            dispatch(setLoader(false));
            return false;
        }
    }
);

export const AddThirdPartyDeviceConfigurationThunk = createAsyncThunk<any, any>(
    "ThirdPartyDeviceConfiguration",
    async (input, { dispatch }) => {

        try {
            dispatch(setLoader(true));
            const response = await API.graphql({
                ...graphqlOperation(AddThirdPartyDeviceConfigurationMutation, { thirdPartyDevicesConfiguration: input }),
                authMode: "AMAZON_COGNITO_USER_POOLS",
            }) as { data: any; errors?: any[] };

            if (response?.data?.AddThirdPartyDeviceConfiguration?.success === "true") {
                dispatch(notificationSuccess(response?.data?.AddThirdPartyDeviceConfiguration?.message));
            } else {
                dispatch(notificationFail(response?.data?.AddThirdPartyDeviceConfiguration?.message));
            }

            dispatch(setLoader(false));

        } catch (error: any) {
            dispatch(setLoader(false));
        }
    }
);

export const DeleteDeviceConfigurationThunk = createAsyncThunk<any, any>(
    "DeleteDeviceConfiguration",
    async (input, { dispatch }) => {

        try {
            const response = await API.graphql({
                ...graphqlOperation(DeleteDeviceConfigurationMutation, { deleteDeviceConfiguration: input }),
                authMode: "AMAZON_COGNITO_USER_POOLS",
            }) as { data: any; errors?: any[] };

            console.log("DeleteDeviceConfigurationMutation response ::", response);

            if (response?.data?.deleteDeviceConfiguration?.success === "true") {
                dispatch(notificationSuccess(response?.data?.deleteDeviceConfiguration?.message));
            } else {
                dispatch(notificationFail(response?.data?.deleteDeviceConfiguration?.message));
            }

        } catch (error: any) {
            dispatch(setLoader(false));
        }
    }
);

export const getVerkadaDeviceData = createAsyncThunk("verkadaDeviceData", async (_request: any, { dispatch }) => {

    try {

        dispatch(setLoaderMeasurement(true));

        const response = await API.graphql({
            ...graphqlOperation(getVerkadaDeviceDataQuery, { getDeviceData: { ..._request } }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };

        const reading = response?.data?.getVerkadaDeviceData?.readings?.[0];
        if (reading) {
            dispatch(setThirdPartyDeviceReading(reading));
        }
        dispatch(setLoaderMeasurement(false));
        return response?.data?.getVerkadaDeviceData?.readings;

    } catch (err: any) {
        dispatch(setLoaderMeasurement(false));
    }
})

